import type { MailboxInfo } from 'owa-client-types';
import type InboxViewType from 'owa-service/lib/contract/InboxViewType';
import { mutatorAction } from 'satcheljs';
import { getStore } from '../store/store';

export const changeInboxViewTypeMutator: (
    viewType: InboxViewType,
    mailboxInfo: MailboxInfo
) => void = mutatorAction(
    'changeInboxViewType',
    (viewType: InboxViewType, mailboxInfo: MailboxInfo): void => {
        getStore(mailboxInfo).viewType = viewType;
    }
);

export const updateUniqueSendersAndUnseenCountMutator: (
    mailboxInfo: MailboxInfo,
    uniqueSenders?: string,
    unseenCountToDisplay?: string
) => void = mutatorAction(
    'updateUniqueSendersAndUnseenCount',
    (mailboxInfo: MailboxInfo, uniqueSenders?: string, unseenCountToDisplay?: string): void => {
        const store = getStore(mailboxInfo);
        store.uniqueSenders = uniqueSenders;
        store.unseenCountToDisplay = unseenCountToDisplay;
    }
);
